import React, { useContext, useEffect, useRef, useState } from 'react'
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import { NotificationContainer, NotificationManager } from "react-notifications";
import './RequisitionDetails.css';
// From @mui/material
import Autocomplete from '@mui/material/Autocomplete';
import Button from '@mui/material/Button';
import CircularProgress from '@mui/material/CircularProgress';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import FormControl from '@mui/material/FormControl';
import OutlinedInput from '@mui/material/OutlinedInput';
import TextField from '@mui/material/TextField';
import TextareaAutosize from '@mui/material/TextareaAutosize';

// From @mui/icons-material
import CloudUpload from '@mui/icons-material/CloudUpload';
import PersonAdd from '@mui/icons-material/PersonAdd';
import Search from '@mui/icons-material/Search';
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import RecentActivities from '../../components/RecentActivities/RecentActivities.js';
import GetAllRequisitionStatus from "../../apis/getallRequisitionStatus/getAllRequisitionStatus"
import getRequisitionDetailsbyId from '../../apis/getRequisitionDetailsbyId/getRequisitionDetailsbyId';
import getAllDivionByOrg from '../../apis/getAllDivionByOrg/getAllDivisionByOrg';
import recruiterLeaderNameByDivision from '../../apis/recruiterLeadernameByDivision/recruiterLeadernameByDivision';
import updateRequisitionById from '../../apis/updateRequisitionById/updateRequisitionById';
import VisibilityIcon from '@mui/icons-material/Visibility';
import Tooltip from '@mui/material/Tooltip';
import { getClientByOrg } from "../../apis/organisationAdminAPI/manageClient";
import configJSON from "../../Config.json";
import {
    getDivisionByOrg,
}
    from "../../apis/organisationAdminAPI/manageDivision";
import getLocations from '../../apis/getLocations/getLocations';
import FileCopyIcon from '@mui/icons-material/FileCopy';
import { UserTypeContext } from '../../AppRoute';
import TeamLeaderRequistionAssignment from '../../components/RequisitionAssignment/TeamLeaderRequistionAssignment';
import RecruiterRequisitionAssignment from '../../components/RequisitionAssignment/RecruiterRequisitionAssignment';
import UploadResumeModal from '../../components/UploadResumeModal/UploadResumeModal';
import checkRequisitionExists from '../../apis/checkRequisitionExists/checkRequisitionExists';
import spocByClientid from '../../apis/spocByClientid';
import teamMovementCheck from '../../apis/teamMovement/teamMovement';
import transferArrow from '../../resources/images/transferArrow.svg'
import updateAssignedRecruitmentLeader from '../../apis/requisitionDetails/updateAssignedRecruitmentLeader';
import RadioGroup from '@mui/material/RadioGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import Radio from '@mui/material/Radio';

const stylesSX = {
    customTextArea: {
        border: '1px solid lightgrey',
        borderRadius: '5px',
        padding: '8px',
        fontSize: '16px',
        fontFamily: 'Segoe UI',
        maxHeight: '100%',
        maxWidth: '100%',
        marginBottom: '10px',
        '&:focus': {
            outline: 'none',
            border: '1px solid lightgrey',
        },
    },
    // Tooltip styles from useStylesBootstrap
    arrow: {
        color: '#1A8FFF',
    },
    tooltip: {
        backgroundColor: '#1A8FFF',
        padding: '4px 13px',
        fontFamily: 'Segoe-Semibold',
        fontSize: '13px',
    },
};


function RequisitionDetailsBody(props) {

    const location = useLocation();
    const history = useNavigate();
    const { userType, userRecords } = useContext(UserTypeContext);
    const idContextTest = location?.state?.id ? location?.state?.id : userRecords?.id;
    const userRecruitmentpartnerId = location?.state?.userRecruitmentpartnerId ? location?.state?.userRecruitmentpartnerId : userRecords?.recruitmentpartnerId;
    const userRole = location?.state?.userRole ? location?.state?.userRole : userRecords?.role?.roleName;

    const { id: requisitionId } = useParams()

    const [requisitionResponseData, setRequisitionResponseData] = useState([])
    const [isClientChanged, setisClientChanged] = useState(false)
    const [status, setStatus] = useState([]);
    const [isDataLoading, setIsDataLoading] = useState(true);
    const [divisionByOrgData, setDivisionByOrgData] = useState([])
    // Placement type options (add legacy if needed)
    const [placementTypeOption, setPlacementTypeOption] = useState([
        { PositionType: "Full Time" },
        { PositionType: "Contract" }
    ]);
    const [clientNameOption, setClientNameOption] = useState([])
    const [divisionName, setDivisionName] = useState([]);
    const [pocName, setpocName] = useState([]);
    const priority = [{ name: "High" }, { name: "Low" }];
    const [allRecruiterLeader, setallRecruiterLeader] = useState([]);
    const currencyBillRate = [
        { value: "INR/HOUR" }, { value: "INR/DAY" }, { value: "INR/YEAR" }
    ]
    const [modalIsOpen, setmodalIsOpen] = useState(false);
    const [showResumeModal, setShowResumeModal] = useState(false)
    const [cloneRequisitionModal, setCloneRequisitionModal] = useState(false)
    const [locationSearchText, setLocationSearchText] = useState("")
    const [locationLoading, setLocationLoading] = useState(false)
    const [locationList, setLocationList] = useState([])
    const [isReferenceIdCopied, setisReferenceIdCopied] = useState(false);
    const [atvBtn, setAtvBtn] = useState(false);
    const [recruiterModalIsOpen, setRecruiterModalIsOpen] = useState(false);
    const [selectedTeam, setSelectedTeam] = useState({});
    const teamLeaderRequisitionRef = useRef(); // reference for Child component
    const recruiterRequisitionRef = useRef(); // reference for Child component
    const [oldData, setOldData] = useState({})
    const [openRecuitmentLeaderChangeDialog, setopenRecuitmentLeaderChangeDialog] = useState(false);
    const [isPOCFetched, setIsPOCFetched] = useState(false);




    // Update the initial state
    const [requisitionDetailsData, setrequisitionDetailsData] = useState(
        {
            reqreferenceId: "",
            primarySkill: "",
            placementType: null,
            clientJobId: "",
            clientName: null,
            endClientName: "",
            division: null,
            priority: null,
            location: [],
            minimumBillRate: "",
            maxiMumBillRate: "",
            currency: null,
            fee: "",
            startDate: "",
            endDate: "",
            openings: "",
            minimumExperienceLevel: "",
            maximumExperienceLevel: "",
            status: null,
            filledBy: "",
            assignedTo: null,
            jobDescription: "",
            documentLink: "",
            poc: null,
            comment: ""
        }
    )

    const [recruitmentLeaderChangeObject, setRecruitmentLeaderChangeObject] = useState({
        oldRecuitmentLeader: null,
        selectedDivision: null,
        newRecuitmentLeader: null,
        isDataLoading: false,
        divisionList: [],
        recruiterLeaderList: [],
        isDataUpdating: false,
    })

    const [activCount, setactivCount] = useState({});
    const changeCopyText = () => {
        setisReferenceIdCopied(false);
    };
    const copyReferenceId = (e, referenceId) => {
        setisReferenceIdCopied(true);
        navigator.clipboard.writeText(referenceId);
        setTimeout(changeCopyText, 3000);
    };

    function BootstrapTooltip(props) {

        return <Tooltip arrow
            componentsProps={{ tooltip: { sx: stylesSX.tooltip }, arrow: { sx: stylesSX.arrow, } }} {...props} />
    }
    const getWrappedReferenceId = (refId) => {
        return (
            <BootstrapTooltip title={isReferenceIdCopied ? "Copied" : "Click to copy Reference Id"}>
                <div
                    className='reqDetails-referenceId'
                    onClick={(e) => copyReferenceId(e, refId)}
                >
                    {refId}
                    <FileCopyIcon style={{ marginRight: '5px', color: '#31B3F8' }} />

                </div>
            </BootstrapTooltip>
        );
    }

    const goToDashBoard = () => {
        if (userType === "MIS Operator" || (userType === "Admin" && userRole === "MIS Operator")) {
            history("/requisition-dashboard",
                {
                    state: { id: idContextTest, recruitmentPartnerId: userRecruitmentpartnerId, userType: userType, userRecords: userRecords, userRole: userRole },
                });
        } else {
            history("/dashboard",
                {
                    state: {
                        userType: userType,
                        recruitmentPartnerId: userRecruitmentpartnerId,
                        id: idContextTest,
                        userRecords: userRecords,
                        roleName: userRole
                    }
                });
        }
    };

    const goToSearchCandidate = () => {
        history(`/candidate-search-talent-community/${requisitionId}`,
            {
                state: { id: idContextTest, recruitementPartnerId: userRecruitmentpartnerId, userType: userType, userRecords: userRecords, userRole: userRole },
            });
    }

    const openModal = async () => {
        teamLeaderRequisitionRef.current.setTemLeaderRequisitionsData(); //Trigerring the child component function
        setmodalIsOpen(true);
    }
    const closeModal = () => {
        teamLeaderRequisitionRef.current.clearTeamLeaderRequistionData(); //Trigerring the child component function
        setmodalIsOpen(false);
    }

    const handleUploadResumes = () => {
        setShowResumeModal(true);
    }

    const cloneConfirmRequisitionHandler = () => {
        setCloneRequisitionModal(true);
    }

    const closeCloneRequisitionModal = () => {
        setCloneRequisitionModal(false);
    }

    const mapLegacyPlacementType = (placementType) => {
        if (!placementType) return placementType;
        if (placementType === "Direct Placement") return "Permanent";
        if (placementType === "Right To Hire") return "Contract";
        return placementType;
    };


    const getRequisitionDetail = async (step) => {
        try {
            setIsDataLoading(true)
            let requisitionResponse = await getRequisitionDetailsbyId(requisitionId, { userType: userType === 'Admin' ? userRole : userType, id: idContextTest, recruitmentpartnerId: userRecruitmentpartnerId, userRecruitmentpartnerId: userRecruitmentpartnerId, userId: idContextTest })
            requisitionResponse = requisitionResponse?.data?.data[0]
            setRequisitionResponseData(requisitionResponse)

            let ClientResponse = []
            let requisitionStatusResponse = []
            let pocResponse

            if (step === 'initial') {

                requisitionStatusResponse = await GetAllRequisitionStatus();
                setStatus(requisitionStatusResponse?.data?.data)
                requisitionStatusResponse = requisitionStatusResponse?.data?.data

                if (requisitionResponse?.teamLeaderRequisitionDetails?.length === 0) {
                    ClientResponse = await getClientByOrg({ recruitmentPartnerId: userRecruitmentpartnerId, isActive: true });
                    setClientNameOption(ClientResponse?.data?.data)
                    ClientResponse = ClientResponse?.data?.data

                    let payload = {
                        isManageClient: false
                    }
                    await getAllDivionByOrg(userRecruitmentpartnerId, payload);
                    recruiterLeaderByDivision(requisitionResponse?.divisionId, requisitionResponse?.clientDetails?._id)
                }
            }
            else {
                ClientResponse = clientNameOption
                requisitionStatusResponse = status
            }

            let isDisabled = true;
            let clientNameData = requisitionResponse?.teamLeaderRequisitionDetails?.length === 0 ?
                (ClientResponse.filter((item) => item._id === requisitionResponse?.clientDetails?._id))[0] : requisitionResponse?.clientDetails
            let pocNameData

            if (userType === 'MIS Operator') {
                if (requisitionResponse?.recruiterLeaderRequisitionDetails?.status?.statusCode === configJSON?.requisitionStatusCodes?.OPEN &&
                    requisitionResponse?.recruiterLeaderRequisitionDetails?.status?.subCode === configJSON?.requisitionStatusCodes?.OPENSUBSTATUS?.UNASSIGNED) {
                    isDisabled = false
                }

                pocResponse = await spocByClientid(clientNameData._id, userRecruitmentpartnerId);
                pocNameData = (pocResponse?.data?.data.filter((item) => item._id === requisitionResponse?.spocId))[0];
                const arr = pocResponse?.data?.data.flatMap(item => item);
                setpocName(arr || [])
            }
            let divisionNameData = requisitionResponse?.divisionDetails
            setrequisitionDetailsData({
                ...requisitionDetailsData,
                poc: pocNameData || requisitionResponse?.spocDetails[0] || '',
                requisitionDetailId: requisitionResponse?._id,
                primarySkill: requisitionResponse?.primarySkill,
                reqreferenceId: requisitionResponse?.reqreferenceId,
                placementType: mapLegacyPlacementType(requisitionResponse?.placementType),
                clientJobId: requisitionResponse?.clientJobId,
                clientName: clientNameData,
                endClientName: requisitionResponse?.endClientName,
                priority: priority.filter((item) => item.name === requisitionResponse?.priority)[0],
                minimumBillRate: requisitionResponse?.billRate?.minimum,
                maxiMumBillRate: requisitionResponse?.billRate?.maximum,
                currency: currencyBillRate.filter((item) => item.value === requisitionResponse?.currency)[0],
                fee: requisitionResponse?.fee,
                location: requisitionResponse?.location,
                startDate: new Date(requisitionResponse?.startDate) || "",
                endDate: new Date(requisitionResponse?.endDate) || "",
                openings: requisitionResponse?.openings,
                jobDescription: requisitionResponse?.jobDescription,
                minimumExperienceLevel: requisitionResponse?.minExperience,
                maximumExperienceLevel: requisitionResponse?.maxExperience,
                status: (requisitionStatusResponse.filter((item) => item._id === requisitionResponse?.status?.statusCodeId))[0],
                filledBy: requisitionResponse?.filledBy,
                filledByDetails: requisitionResponse?.filledByDetails,
                division: divisionNameData,
                assignedTo: requisitionResponse?.recruiterLeaderDetails,
                isDisabled: isDisabled,
                documentLink: requisitionResponse?.uploadDocuments,
                oldAssignedTo: requisitionResponse?.recruiterLeaderDetails,
                placementTemplateCode: requisitionResponse?.placementTemplateCode,
                comment: requisitionResponse?.comment || ""
            });
            setOldData({ openings: requisitionResponse?.openings, status: (requisitionStatusResponse.filter((item) => item._id === requisitionResponse?.status?.statusCodeId))[0] })
            setIsDataLoading(false)
            const divi1 = requisitionResponse?.teamLeaderRequisitionDetails?.length === 0 ? clientNameData?.assignedDivisions : [requisitionResponse?.divisionDetails]
            const arr1 = divi1.flatMap(item => item)
            setDivisionName(arr1);

        } catch (error) {
            console.log(error)
        }

    }

    const allDivisonData = async () => {
        let payload = {
            recruitmentpartnerId: userRecruitmentpartnerId,
            isActive: true
        }
        try {
            let response = await getDivisionByOrg(payload);
            setDivisionByOrgData(response?.data?.data)
        } catch (error) {
            console.log(error);
        }
    };

    useEffect(() => {
        if (userRecruitmentpartnerId) {
            getRequisitionDetail('initial')
            allDivisonData()
            allRequisitionStatus();
            if (userType === 'MIS Operator') {
                setrequisitionDetailsData([]);
            }
        }
    }, [requisitionId, userType])

    //----------- Field Handlers ------------

    const primarySkillHandler = (e) => {
        const value = e.target.value;
        if (value) {
            setrequisitionDetailsData({ ...requisitionDetailsData, primarySkill: value });
        } else {
            setrequisitionDetailsData({ ...requisitionDetailsData, primarySkill: "" });
        }
    }
    const placementTypeHandler = (e, value) => {
        setrequisitionDetailsData({ ...requisitionDetailsData, placementType: value || null });
    }

    const clientJobIdHandler = (e) => {
        const value = e.target.value;
        if (value) {
            setrequisitionDetailsData({ ...requisitionDetailsData, clientJobId: e.target.value });
        } else {
            setrequisitionDetailsData({ ...requisitionDetailsData, clientJobId: "" });
        }
    }

    const clientNameChangeHandler = (e, value) => {
        setallRecruiterLeader([]);
        setpocName([]);
        setIsPOCFetched(false);

        if (value) {
            setrequisitionDetailsData(prev => ({
                ...prev,
                clientName: value,
                division: null,
                assignedTo: null,
                poc: null
            }));
            const divisions = value?.assignedDivisions;
            let activeDivisions = (divisions || []).flatMap(item => item);
            activeDivisions = activeDivisions.filter(item => item.isActive === true);
            setDivisionName(activeDivisions);
            setisClientChanged(true);
        } else {
            setrequisitionDetailsData(prev => ({
                ...prev,
                clientName: null,
                division: null,
                assignedTo: null,
                poc: null
            }));
            setDivisionName([]);              // Clear divisions if client cleared
            setisClientChanged(false);
        }
    };

    const getpoc = async (clientId, recruitmentpartnerId) => {
        try {
            let response = await spocByClientid(clientId, recruitmentpartnerId);
            const arr = response?.data?.data.flatMap(item => item);
            setpocName(arr || [])
        } catch (error) {
            console.log(error)
        }
    }

    const endClientNameHandler = (e) => {
        const value = e.target.value;
        if (value) {
            setrequisitionDetailsData({ ...requisitionDetailsData, endClientName: e.target.value });
        } else {
            setrequisitionDetailsData({ ...requisitionDetailsData, endClientName: "" });
        }
    }
    const pocChangeHandler = (e, value) => {
        setrequisitionDetailsData({ ...requisitionDetailsData, poc: value || null });
    }

    const handleFocusFetchPOC = () => {
        const client = requisitionDetailsData?.clientName;
        // Call only if POC hasn't been fetched and a client is selected
        if (!isPOCFetched && client?._id && client?.recruitmentpartnerId) {
            getpoc(client._id, client.recruitmentpartnerId);
            setIsPOCFetched(true);
        }
    };

    const divisionChangeHandler = (e, value) => {
        setallRecruiterLeader([])
        if (value) {
            setrequisitionDetailsData({ ...requisitionDetailsData, division: value, assignedTo: null });
            recruiterLeaderByDivision(value._id, requisitionDetailsData?.clientName?._id)
        } else {
            setrequisitionDetailsData({ ...requisitionDetailsData, division: null, assignedTo: null });
        }
    }

    const recruiterLeaderByDivision = async (id, clientId) => {
        try {
            let recruiterLeaderData = await recruiterLeaderNameByDivision(id, userRecruitmentpartnerId, clientId);
            recruiterLeaderData = recruiterLeaderData?.data?.data;
            setallRecruiterLeader(recruiterLeaderData || []);

        } catch (error) {
            console.log(error);
        }
    }

    const getFilteredRecruiterLeaderOptions = () => {
        let filteredOptions = allRecruiterLeader.filter(item => item?.id !== requisitionDetailsData?.assignedTo?.id)
        return filteredOptions
    }

    const priorityChangeHandler = (e, value) => {
        setrequisitionDetailsData({ ...requisitionDetailsData, priority: value || null });
    }


    const currencyBillRateChangeHandler = (e, value) => {
        setrequisitionDetailsData({ ...requisitionDetailsData, currency: value || null });
    }

    const feeChangeHandler = (event) => {
        setrequisitionDetailsData({ ...requisitionDetailsData, fee: event.target.value });
    }


    const startDateChangeHandler = (date) => {
        setrequisitionDetailsData({ ...requisitionDetailsData, startDate: date });
    };

    const endDateChangeHandler = (date) => {
        setrequisitionDetailsData({ ...requisitionDetailsData, endDate: date });
    }

    const openingChangeHandler = (event) => {
        setrequisitionDetailsData({ ...requisitionDetailsData, openings: event.target.value });
    }

    const minimumExperienceHandler = (event) => {
        setrequisitionDetailsData({ ...requisitionDetailsData, minimumExperienceLevel: event.target.value });
    }

    const maximumExperienceHandler = (event) => {
        setrequisitionDetailsData({ ...requisitionDetailsData, maximumExperienceLevel: event.target.value });
    }


    const allRequisitionStatus = async () => {
        try {
            let response = await GetAllRequisitionStatus();
            setStatus(response?.data?.data)
        } catch (error) {
            console.log(error)
        }
    }

    const statusChangeHandler = (e, value) => {
        if (value) {
            if (value.statusCode === configJSON?.requisitionStatusCodes?.FILLED) {
                setrequisitionDetailsData({ ...requisitionDetailsData, status: value, filledByDetails: requisitionDetailsData?.assignedTo, filledBy: requisitionDetailsData?.assignedTo?.id })
            } else {
                setrequisitionDetailsData({ ...requisitionDetailsData, status: value });
            }
        } else {
            setrequisitionDetailsData({ ...requisitionDetailsData, status: null });
        }
    }

    const filledByChangeHandler = (event) => {
        setrequisitionDetailsData({ ...requisitionDetailsData, filledBy: event.target.value });

    }

    const commentChangeHandler = (event) => {
        setrequisitionDetailsData({ ...requisitionDetailsData, comment: event.target.value });
    }

    const assignToChangeHandler = (e, value) => {
        setrequisitionDetailsData({ ...requisitionDetailsData, assignedTo: value || null });
    }

    const jobDescriptionChangeHandler = (event) => {
        setrequisitionDetailsData({ ...requisitionDetailsData, jobDescription: event.target.value });
    }

    const minimumbillRateChangeHandler = (event) => {
        setrequisitionDetailsData({ ...requisitionDetailsData, minimumBillRate: event.target.value });
    }

    const MaximumbillRateChangeHandler = (event) => {
        setrequisitionDetailsData({ ...requisitionDetailsData, maxiMumBillRate: event.target.value });
    }

    const openResume = (resumeUrl) => {
        window.open(resumeUrl, "_blank");
    };

    const getLocationsBreakDown = (locations) => {
        let city = []
        let state = []
        let country = []
        locations.forEach((item) => {
            let itemArr = item.split(",")
            if (itemArr.length === 1) {
                country.push(itemArr[0].trim())
                state.push(null)
                city.push(null)
            }
            else if (itemArr.length === 2) {
                state.push(itemArr[0].trim())
                country.push(itemArr[1].trim())
                city.push(null)
            }
            else {
                city.push(itemArr[0].trim())
                state.push(itemArr[itemArr.length - 2].trim())
                country.push(itemArr[itemArr.length - 1].trim())
            }
        })
        let locationObj = {
            city: city,
            state: state,
            country: country
        }
        return locationObj;
    }



    const saveHandler = async () => {
        setAtvBtn(true);

        const maxPositions = requisitionResponseData
            ?.teamLeaderRequisitionDetails
            ?.reduce((max, item) => {
                return Math.max(max, item?.no_of_positions || 0);
            }, 0);

        const errorNotifier = (message) => {
            setAtvBtn(false);
            NotificationManager.error(message, "Error", 10000);
        };

        const validations = [
            { condition: !requisitionDetailsData?.primarySkill, message: "Please enter Primary Skill" },
            { condition: requisitionDetailsData?.openings < maxPositions, message: `Opening can't be less than ${maxPositions}` },
            { condition: !requisitionDetailsData?.clientName, message: "Please enter Client Name" },
            { condition: requisitionDetailsData?.location?.length === 0, message: "Please enter Location" },
            { condition: requisitionDetailsData?.openings === 0, message: "Openings should be greater than 0" },
            { condition: !requisitionDetailsData?.openings, message: "Please enter a value in openings" },
            { condition: !requisitionDetailsData?.assignedTo, message: "Please enter Assign To" },
            { condition: !requisitionDetailsData?.division, message: "Please enter Division" },
            { condition: !requisitionDetailsData?.priority, message: "Please enter Priority" },
            { condition: !requisitionDetailsData?.placementType, message: "Please enter Placement Type" },
            {
                condition:
                    parseInt(requisitionDetailsData?.maxiMumBillRate) <
                    parseInt(requisitionDetailsData?.minimumBillRate),
                message: "Minimum Bill Rate cannot be more than Maximum Bill Rate."
            },
            { condition: !requisitionDetailsData?.maximumExperienceLevel, message: "Please enter Maximum Experience" },
            {
                condition: requisitionDetailsData?.minimumExperienceLevel === null ||
                    requisitionDetailsData?.minimumExperienceLevel === undefined ||
                    requisitionDetailsData?.minimumExperienceLevel === "", message: "Please enter Minimum Experience"
            },
            {
                condition:
                    parseInt(requisitionDetailsData?.maximumExperienceLevel) <
                    parseInt(requisitionDetailsData?.minimumExperienceLevel),
                message: "Minimum Experience cannot be more than Maximum Experience."
            },
            {
                condition: requisitionDetailsData?.maximumExperienceLevel < 1,
                message: "Maximum years of Experience cannot be less than 1 year"
            },
            { condition: !requisitionDetailsData?.status, message: "Please enter Status" }
        ];

        for (const { condition, message } of validations) {
            if (condition) return errorNotifier(message);
        }

        const statusCode = requisitionResponseData?.status?.statusCode;
        const newStatusCode = requisitionDetailsData?.status?.statusCode;
        if (
            (statusCode === configJSON?.requisitionStatusCodes?.FILLED ||
                statusCode === configJSON?.requisitionStatusCodes?.CLOSED ||
                statusCode === configJSON?.requisitionStatusCodes?.CANCELLED
            ) &&
            (newStatusCode === configJSON?.requisitionStatusCodes?.OPEN ||
                newStatusCode === configJSON?.requisitionStatusCodes?.ON_HOLD)
        ) {
            const payloadMovement = {
                location: "requisitionDetails",
                requisitionDetailId: requisitionResponseData?._id,
                recruitmentpartnerId: userRecruitmentpartnerId
            };
            try {
                const response = await teamMovementCheck(payloadMovement);
                if (response?.data?.isTeamMovement) {
                    return errorNotifier("Requisition status can't be updated: Team movement detected.");
                }
            } catch (error) {
                console.error("Team Movement Check Error:", error);
                return setAtvBtn(false);
            }
        }

        let isRecruiterLeaderChanged = false;
        if (requisitionDetailsData.assignedTo.id !== requisitionDetailsData?.oldAssignedTo?.id) {
            isRecruiterLeaderChanged = true
        }
        let locationObj = getLocationsBreakDown(requisitionDetailsData?.location);
        let payload = {
            requisitionDetailId: requisitionResponseData?._id,
            primarySkill: requisitionDetailsData?.primarySkill,
            placementType: requisitionDetailsData?.placementType?.PositionType,
            clientJobId: requisitionDetailsData?.clientJobId,
            clientId: requisitionDetailsData?.clientName?._id,
            endClientName: requisitionDetailsData?.endClientName,
            divisionId: requisitionDetailsData?.division?._id,
            city: locationObj?.city,
            state: locationObj?.state,
            country: locationObj?.country,
            location: requisitionDetailsData?.location,
            minimumBillRate: requisitionDetailsData?.minimumBillRate,
            maxiMumBillRate: requisitionDetailsData?.maxiMumBillRate,
            currency: requisitionDetailsData.currency?.value,
            fee: requisitionDetailsData?.fee,
            startDate: requisitionDetailsData?.startDate,
            endDate: requisitionDetailsData?.endDate,
            openings: requisitionDetailsData?.openings,
            maxExperience: requisitionDetailsData?.maximumExperienceLevel,
            minExperience: requisitionDetailsData?.minimumExperienceLevel,
            priority: requisitionDetailsData?.priority?.name,
            filledBy:
                requisitionDetailsData?.status?.statusCode === configJSON?.requisitionStatusCodes?.FILLED
                    ? requisitionDetailsData?.assignedTo?.id
                    : "",
            recruitmentLeaderId: requisitionDetailsData?.assignedTo?.id,
            recruitmentLeaderEmailId: requisitionDetailsData?.assignedTo?.email,
            jobDescription: requisitionDetailsData?.jobDescription,
            misOperatorDetails: { id: userRecords?.id, name: userRecords?.displayName },
            oldAssignedTo: requisitionDetailsData?.oldAssignedTo,
            isRecruiterLeaderChanged,
            isClientChanged,
            reqreferenceId: requisitionDetailsData?.reqreferenceId,
            recruitmentpartnerId: userRecruitmentpartnerId,
            userRecruitmentpartnerId: userRecruitmentpartnerId,
            userId: idContextTest,
            spocId: requisitionDetailsData?.poc?._id || null,
            isChanged: {
                openings: parseInt(oldData?.openings) !== parseInt(requisitionDetailsData?.openings)
            },
            openToFilledChange: false,
            placementTemplateCode: requisitionDetailsData?.placementTemplateCode,
            comment: requisitionDetailsData?.comment || ""
        };

        const openStatus = status.find((s) => s.statusCode === configJSON?.requisitionStatusCodes?.OPEN);
        const subStatusCovered = openStatus?.subList.find(
            (s) => s.subCode === configJSON?.requisitionStatusCodes?.OPENSUBSTATUS?.COVERED
        );
        const subStatusUncovered = openStatus?.subList.find(
            (s) => s.subCode === configJSON?.requisitionStatusCodes?.OPENSUBSTATUS?.UNCOVERED
        );

        const subStatusUnassigned = openStatus?.subList.find(
            (s) => s.subCode === configJSON?.requisitionStatusCodes?.OPENSUBSTATUS?.UNASSIGNED
        );

        try {
            if (
                requisitionDetailsData.status.statusCode === configJSON?.requisitionStatusCodes?.OPEN &&
                statusCode === configJSON?.requisitionStatusCodes?.OPEN
            ) {

                const response = await checkRequisitionExists({
                    validation: "requisitionAssignedCandidates",
                    requisitionDetailId: requisitionResponseData?._id,
                    recruitmentpartnerId: userRecruitmentpartnerId
                });

                const data = response?.data?.data || [];
                const selected = data.find((d) => d._id.candidateStatusCode === configJSON?.candidateRequisitionStatusCode?.SELECTED)?.count || 0;
                const started = data.find((d) => d._id.candidateStatusCode === configJSON?.candidateRequisitionStatusCode?.STARTED)?.count || 0;
                const filledStatus = status.find((s) => s.statusCode === configJSON?.requisitionStatusCodes?.FILLED);

                if (requisitionDetailsData.openings <= started) {
                    payload.status = {
                        statusCode: filledStatus?.statusCode,
                        statusCodeId: filledStatus?._id,
                        subCode: requisitionResponseData?.status?.subCode,
                        subCodeId: requisitionResponseData?.status?.subCodeId
                    };
                    payload.filledBy = requisitionDetailsData?.assignedTo?.id;
                } else if (requisitionDetailsData.openings <= selected + started) {
                    payload.status = {
                        statusCode: openStatus?.statusCode,
                        statusCodeId: openStatus?._id,
                        subCode: subStatusCovered?.subCode,
                        subCodeId: subStatusCovered?._id
                    };
                } else if (
                    requisitionResponseData.status.subCode === configJSON?.requisitionStatusCodes?.OPENSUBSTATUS?.COVERED &&
                    requisitionDetailsData.openings > selected + started
                ) {
                    payload.status = {
                        statusCode: openStatus?.statusCode,
                        statusCodeId: openStatus?._id,
                        subCode: subStatusUncovered?.subCode,
                        subCodeId: subStatusUncovered?._id
                    };
                } else {
                    payload.status = {
                        statusCode: requisitionDetailsData?.status?.statusCode,
                        statusCodeId: requisitionDetailsData?.status?._id,
                        subCode: requisitionResponseData?.status?.subCode,
                        subCodeId: requisitionResponseData?.status?.subCodeId
                    };
                }
            } else {
                let updatedStatus = {
                    statusCode: requisitionDetailsData?.status?.statusCode,
                    statusCodeId: requisitionDetailsData?.status?._id,
                    subCode: requisitionResponseData?.status?.subCode,
                    subCodeId: requisitionResponseData?.status?.subCodeId
                }
                if (
                    (statusCode === configJSON?.requisitionStatusCodes?.FILLED ||
                        statusCode === configJSON?.requisitionStatusCodes?.CLOSED ||
                        statusCode === configJSON?.requisitionStatusCodes?.CANCELLED
                    ) &&
                    (newStatusCode === configJSON?.requisitionStatusCodes?.OPEN ||
                        newStatusCode === configJSON?.requisitionStatusCodes?.ON_HOLD)
                    ) {
                        let candidateRes = await checkRequisitionExists({
                            validation: "requisitionAssignedCandidates",
                            requisitionDetailId: requisitionResponseData?._id,
                            recruitmentpartnerId: userRecruitmentpartnerId
                        });
                        candidateRes = candidateRes?.data?.data || [];
                        const selectedCount = candidateRes.find((d) => d._id.candidateStatusCode === configJSON?.candidateRequisitionStatusCode?.SELECTED)?.count || 0;
                        const startedCount = candidateRes.find((d) => d._id.candidateStatusCode === configJSON?.candidateRequisitionStatusCode?.STARTED)?.count || 0;
                        if(requisitionDetailsData.openings <= selectedCount + startedCount) {
                            updatedStatus.subCode = subStatusCovered?.subCode;
                            updatedStatus.subCodeId = subStatusCovered?._id
                        }
                        else{
                            let teamleaderReqs = requisitionResponseData?.teamLeaderRequisitionDetails || []
                            let unAssignedCount = 0
                            for( const tlreqs of teamleaderReqs) {
                                if(tlreqs.status?.subCode === configJSON?.requisitionStatusCodes?.OPENSUBSTATUS?.UNASSIGNED) {
                                    unAssignedCount ++;
                                    break
                                }
                            }
                            if(unAssignedCount > 0) {
                                updatedStatus.subCode = subStatusUnassigned?.subCode;
                                updatedStatus.subCodeId = subStatusUnassigned?._id
                            }
                            else{
                                updatedStatus.subCode = subStatusUncovered?.subCode;
                                updatedStatus.subCodeId = subStatusUncovered?._id
                            }
                        }

                    }
                payload.status = updatedStatus;
            }

            payload.isChanged.status =
                oldData?.status?.statusCode !== payload?.status?.statusCode ||
                oldData?.status?.subCode !== payload?.status?.subCode;
            await updateRequisitionById(requisitionId, payload);
            NotificationManager.success("Requisition updated successfully", "Success", 10000);
            getRequisitionDetail();
        } catch (error) {
            NotificationManager.error(
                error?.response?.data?.errMessage || "Something went wrong",
                "Error",
                10000
            );
        } finally {
            setAtvBtn(false);
        }
    };


    const cloneRequisitionHandler = async () => {

        const openStatus = status.find((item) => item.statusCode === configJSON?.requisitionStatusCodes?.OPEN)

        const cloneRequistion_data = {
            reqreferenceId: requisitionDetailsData?.reqreferenceId,
            primarySkill: requisitionDetailsData?.primarySkill,
            placementType: requisitionDetailsData?.placementType,
            endClientName: requisitionDetailsData?.endClientName,
            priority: requisitionDetailsData?.priority,
            location: requisitionDetailsData?.location,
            minimumBillRate: requisitionDetailsData?.minimumBillRate,
            maxiMumBillRate: requisitionDetailsData?.maxiMumBillRate,
            currency: requisitionDetailsData?.currency,
            fee: requisitionDetailsData?.fee,
            startDate: requisitionDetailsData?.startDate,
            endDate: requisitionDetailsData?.endDate,
            openings: requisitionDetailsData?.openings,
            minimumExperienceLevel: requisitionDetailsData?.minimumExperienceLevel,
            maximumExperienceLevel: requisitionDetailsData?.maximumExperienceLevel,
            status: openStatus,
            filledBy: requisitionDetailsData?.filledBy,
            jobDescription: requisitionDetailsData?.jobDescription,
            documentLink: requisitionDetailsData?.documentLink,
        }


        history("/create-requisition",
            {
                state: { requisitionData: cloneRequistion_data, divisionName: divisionName, isClone: true }
            });
    }

    const locationTextFieldChangeHandler = (e) => {
        setLocationLoading(true)
        setLocationList([])
        setLocationSearchText(e.target.value)
    }
    const locationChangeHandler = (e, value) => {
        if (value) {
            setrequisitionDetailsData({ ...requisitionDetailsData, location: value });
        } else {
            setrequisitionDetailsData({ ...requisitionDetailsData, location: [] });
        }
        setLocationList([])
        setLocationSearchText("")
    }

    const getLocationResult = async (searchText) => {
        try {
            let response = await getLocations(searchText)
            response = response?.data?.data
            let locationArr = []
            response.forEach((item) => {
                let str = ""
                str += (item.name).trim()
                if (item.state) {
                    str += ", " + (item?.state?.name).trim()
                }
                if (item.country) {
                    str += ", " + (item?.country?.name).trim()
                }
                locationArr.push(str)
            })
            setLocationList(locationArr)
            setTimeout(() => {
                setLocationLoading(false);
            }, 1000);
        } catch (error) {
            console.log(error)
        }
    }

    const openRecruiterRequisitionModal = () => {
        recruiterRequisitionRef.current.addRecruiterAssigment() //reference for Child component
        setRecruiterModalIsOpen(true)
    }
    const closeRecruiterRequisitionModal = (handlerAction) => {
        recruiterRequisitionRef.current.clearRecruiterRequistionData() //Trigerring the child component function
        setRecruiterModalIsOpen(false)
        if (handlerAction?.action !== "save") {
            if (userType === "MIS Operator" || userType === "Organization Admin" || userType === "Recruitment Leader") {
                teamLeaderRequisitionRef.current.handleRecruiterAssignment() //Trigerring the child component function
            }
        }
        else {
            teamLeaderRequisitionRef.current.clearTeamLeaderAssignmentData() //Trigerring the child component function
            setSelectedTeam({})
        }
    }

    const openChangeRecruitmentLeaderHandler = () => {
        setRecruitmentLeaderChangeObject({
            ...recruitmentLeaderChangeObject,
            isDataLoading: true,
        })
        setopenRecuitmentLeaderChangeDialog(true);
    }

    const fetchDivisionList = async () => {
        try {

            let clientId = requisitionDetailsData?.clientName?._id
            let response = await getDivisionByOrg({
                recruitmentpartnerId: userRecruitmentpartnerId,
                isActive: true,
                clientId: clientId
            })
            response = response?.data?.data || [];

            let currentDivisionId = requisitionDetailsData?.division?._id || "";

            let selectedDivision = response.find((item) => item._id === currentDivisionId)

            let updatedRecruiterLeaderList = selectedDivision?.recruiterLeaderDetails || [];
            updatedRecruiterLeaderList = updatedRecruiterLeaderList.filter((item) => item.email !== requisitionDetailsData?.assignedTo?.email)

            setRecruitmentLeaderChangeObject({
                ...recruitmentLeaderChangeObject,
                oldRecuitmentLeader: requisitionDetailsData?.assignedTo || {},
                divisionList: response,
                selectedDivision: selectedDivision,
                recruiterLeaderList: updatedRecruiterLeaderList,
                isDataLoading: false,
            })

        } catch (error) {
            NotificationManager.error("Something went wrong", "Error", 10000);
            console.log(error);
        }
    }

    const divisionChangeHandler_recruitmentLeaderChange = (value) => {
        if (value) {
            let updatedRecruiterLeaderList = value?.recruiterLeaderDetails || [];
            updatedRecruiterLeaderList = updatedRecruiterLeaderList.filter((item) => item.email !== recruitmentLeaderChangeObject?.oldRecuitmentLeader?.email)
            setRecruitmentLeaderChangeObject({
                ...recruitmentLeaderChangeObject,
                selectedDivision: value,
                recruiterLeaderList: updatedRecruiterLeaderList,
                newRecuitmentLeader: null,
            });
        }
        else {
            setRecruitmentLeaderChangeObject({
                ...recruitmentLeaderChangeObject,
                selectedDivision: null,
                recruiterLeaderList: [],
                newRecuitmentLeader: null,
            });
        }
    }

    const recruitmentLeaderChangeHandler_reassignRecruiterLeader = (value) => {
        if (value) {
            setRecruitmentLeaderChangeObject({
                ...recruitmentLeaderChangeObject,
                newRecuitmentLeader: value
            });
        } else {
            setRecruitmentLeaderChangeObject({
                ...recruitmentLeaderChangeObject,
                newRecuitmentLeader: null
            });
        }
    }

    const handleRecruitmentLeaderChange = async () => {
        try {
            setRecruitmentLeaderChangeObject({
                ...recruitmentLeaderChangeObject,
                isDataUpdating: true,
            })

            if (recruitmentLeaderChangeObject?.selectedDivision?._id && recruitmentLeaderChangeObject?.newRecuitmentLeader?.id) {
                let payload = {
                    requisitionDetailId: requisitionResponseData?._id,
                    oldRecuitmentLeaderId: recruitmentLeaderChangeObject?.oldRecuitmentLeader?.id,
                    newRecuitmentLeaderId: recruitmentLeaderChangeObject?.newRecuitmentLeader?.id,
                    oldDivisionId: requisitionDetailsData?.division?._id,
                    newDivisionId: recruitmentLeaderChangeObject?.selectedDivision?._id,
                    recruitmentpartnerId: userRecruitmentpartnerId,
                    userId : idContextTest
                }

                let response = await updateAssignedRecruitmentLeader(payload);
                if (response.status === 200) {
                    NotificationManager.success(response?.data?.message, "Success", 10000);
                    setRecruitmentLeaderChangeObject({
                        ...recruitmentLeaderChangeObject,
                        isDataUpdating: false,
                    })
                    setopenRecuitmentLeaderChangeDialog(false);
                    getRequisitionDetail();
                }
                else {
                    NotificationManager.error(response?.data?.message || "Something went wrong", "Error", 10000);
                    setRecruitmentLeaderChangeObject({
                        ...recruitmentLeaderChangeObject,
                        isDataUpdating: false,
                    })
                }

            }
            else {
                NotificationManager.error("Please fill all required fields.", "Error", 10000);
            }

        } catch (error) {
            console.log(error);
            NotificationManager.error("Error while changing the recruitment leader", "Error", 10000);
        }
    }

    useEffect(() => {
        if (recruitmentLeaderChangeObject.isDataLoading) {
            fetchDivisionList();
        }
    }, [recruitmentLeaderChangeObject])


    useEffect(() => {
        const timeout = setTimeout(() => {
            if (locationSearchText.length > 0) {
                setLocationLoading(true)
                getLocationResult(locationSearchText)
            }
            else {
                setLocationLoading(false)
                setLocationList([])
            }
        }, 700);

        return () => clearTimeout(timeout);
    }, [locationSearchText])


    return (
        <div className='reqDetailsContainer'>
            <div className="communityHeader">
                <div className="goBackButton" onClick={(e) => goToDashBoard(e)}>
                    <Tooltip title={userType === "MIS Operator" ? "Go Back to Requisition Dashboard" : "Go Back to Dashboard"} placement="bottom">
                        <ArrowBackIcon sx={{ fontSize: 20 }} />
                    </Tooltip>
                    {/* <span>&nbsp;Go Back to Dashboard</span> */}
                </div>
                <div className="communityTitle">Requisition Details</div>

            </div>

            <div className='reqDetailsGrid'>
                {isDataLoading ? <div className='loader_requisitionDetails'>
                    <CircularProgress />
                </div> :
                    <div className='reqDetailsLeftFormContainer'>
                        <div className='reqDetailsLeftCardGrid'>
                            {
                                requisitionDetailsData?.reqreferenceId ?
                                    <div className='reqDetailsBasicInfo'>
                                        <div>
                                            <div className='reqDetails_headings'>Reference ID</div>
                                            <div className="candidateDetails">{requisitionDetailsData?.reqreferenceId ?
                                                getWrappedReferenceId(requisitionDetailsData?.reqreferenceId)
                                                : ""}</div>
                                        </div>
                                    </div>
                                    : ""
                            }
                            <div className='reqDetailsBasicInfo'>
                                <div className='reqDetails_headings'>Primary Skill*</div>
                                <FormControl fullWidth variant="outlined">
                                    <OutlinedInput
                                        placeholder="Primary Skills"
                                        className="createRequisition_textbox_outline"
                                        disabled={userType !== "MIS Operator" || requisitionDetailsData?.status?.statusCode === configJSON?.requisitionStatusCodes?.FILLED}
                                        value={requisitionDetailsData?.primarySkill || ""}
                                        onChange={primarySkillHandler}
                                    />
                                </FormControl>
                            </div>
                            <div className='reqDetailsBasicInfo'>
                                <div className='reqDetails_headings'>Placement Type*</div>
                                <Autocomplete
                                    id="multiple-limit-tags"
                                    className="createRequisition_textbox"
                                    options={placementTypeOption}
                                    disabled={true}
                                    // disabled={userType === "MIS Operator" ? requisitionDetailsData?.isDisabled || (requisitionResponseData?.teamLeaderRequisitionDetails || [])?.length > 0 : true}
                                    getOptionLabel={(option) => {
                                        if (option.PositionType === "Full Time" || option.PositionType === "Permanent" || option.PositionType === "Direct Placement") return "Permanent";
                                        if (option.PositionType === "Contract" || option.PositionType === "Contractual" || option.PositionType === "Right To Hire") return "Contract";
                                        return option.PositionType || "";
                                    }}
                                    getOptionSelected={(option, value) => option?.PositionType === value?.PositionType}
                                    value={
                                        placementTypeOption.find(
                                            (opt) =>
                                                opt.PositionType === requisitionDetailsData?.placementType ||
                                                (opt.PositionType === "Full Time" && requisitionDetailsData?.placementType === "Permanent") ||
                                                (opt.PositionType === "Contract" && requisitionDetailsData?.placementType === "Contractual")
                                        ) || null
                                    }
                                    onChange={placementTypeHandler}
                                    filterSelectedOptions
                                    renderInput={(params) =>
                                        <TextField
                                            {...params}
                                            variant="outlined"
                                            required={true}
                                            placeholder="Placement Type"
                                        />
                                    }
                                />
                            </div>
                            <div className='reqDetailsBasicInfo'>
                                <div className='reqDetails_headings'>Template</div>
                                <FormControl component="fieldset">
                                    <RadioGroup
                                        aria-label="placementTemplateCode"
                                        name="placementTemplateCode"
                                        value={requisitionDetailsData?.placementTemplateCode || ""}
                                        onChange={(e) =>
                                            setrequisitionDetailsData({ ...requisitionDetailsData, placementTemplateCode: e.target.value })
                                        }
                                        className="template_radio_group"
                                    >
                                        <FormControlLabel
                                            value="PC01"
                                            control={<Radio color="primary" />}
                                            label="Permanent"
                                            disabled={true}
                                        // disabled={userType === "MIS Operator" ? requisitionDetailsData?.isDisabled || (requisitionResponseData?.teamLeaderRequisitionDetails || [])?.length > 0 || requisitionDetailsData?.placementTemplateCode : true}
                                        />
                                        <FormControlLabel
                                            value="PC02"
                                            control={<Radio color="primary" />}
                                            label="Contractual"
                                            disabled={true}
                                        // disabled={userType === "MIS Operator" ? requisitionDetailsData?.isDisabled || (requisitionResponseData?.teamLeaderRequisitionDetails || [])?.length > 0 || requisitionDetailsData?.placementTemplateCode : true}
                                        />
                                    </RadioGroup>
                                </FormControl>
                            </div>
                            <div className='reqDetailsBasicInfo'>
                                <div className='reqDetails_headings'>Client JobId</div>
                                <FormControl fullWidth variant="outlined">
                                    <OutlinedInput
                                        placeholder="Client JobId"
                                        className="createRequisition_textbox_outline"
                                        disabled={userType !== "MIS Operator" || requisitionDetailsData?.status?.statusCode === configJSON?.requisitionStatusCodes?.FILLED}
                                        value={requisitionDetailsData?.clientJobId || ""}
                                        onChange={clientJobIdHandler}
                                    />
                                </FormControl>
                            </div>
                            <div className='reqDetailsBasicInfo'>
                                <div className='reqDetails_headings'>Client Name*</div>
                                <Autocomplete
                                    id="multiple-limit-tags"
                                    className="createRequisition_textbox"
                                    options={clientNameOption}
                                    disabled={userType === "MIS Operator" ? requisitionDetailsData?.isDisabled || (requisitionResponseData?.teamLeaderRequisitionDetails || [])?.length > 0 : true}
                                    getOptionLabel={(option) => option.clientName || ""}
                                    getOptionSelected={(option, value) => option?._id === value?._id}
                                    value={requisitionDetailsData?.clientName || null}
                                    onChange={clientNameChangeHandler}
                                    filterSelectedOptions
                                    renderInput={(params) =>
                                        <TextField
                                            {...params}
                                            variant="outlined"
                                            required={true}
                                            placeholder="Client Name"
                                        />
                                    }
                                />
                            </div>
                            <div className='reqDetailsBasicInfo'>
                                <div className='reqDetails_headings'>End Client Name</div>
                                <FormControl fullWidth variant="outlined">
                                    <OutlinedInput
                                        placeholder="End Client Name"
                                        className="createRequisition_textbox_outline"
                                        disabled={userType !== "MIS Operator" || requisitionDetailsData?.status?.statusCode === configJSON?.requisitionStatusCodes?.FILLED}
                                        value={requisitionDetailsData?.endClientName || ""}
                                        onChange={endClientNameHandler}
                                    />
                                </FormControl>
                            </div>
                            <div className='reqDetailsBasicInfo'>
                                <div className='reqDetails_headings'>POC</div>
                                <Autocomplete
                                    key={requisitionDetailsData?.poc + requisitionDetailsData}
                                    id="multiple-limit-tags"
                                    options={pocName}
                                    className="createRequisition_textbox"
                                    getOptionLabel={(option) =>
                                        option.spocName ? option.spocName : ""
                                    }
                                    getOptionSelected={(option, value) => option?._id === value?._id}
                                    value={requisitionDetailsData?.poc}
                                    onChange={pocChangeHandler}
                                    onFocus={() => pocName.length > 0 ? null : handleFocusFetchPOC()}
                                    filterSelectedOptions
                                    disabled={
                                        (userType !== "MIS Operator" && userType !== "Organization Admin") ||
                                        requisitionDetailsData?.status?.statusCode === configJSON?.requisitionStatusCodes?.FILLED
                                    }
                                    renderInput={(params) =>
                                        <TextField
                                            {...params}
                                            variant="outlined"
                                            placeholder={"Select Spoc"}
                                        />
                                    }
                                />

                            </div>
                            <div className='reqDetailsBasicInfo'>
                                <div className='reqDetails_headings'>Division*</div>

                                <Autocomplete
                                    id="multiple-limit-tags"
                                    className="createRequisition_textbox"
                                    options={divisionName}
                                    getOptionLabel={(option) => option?.divisionName || ""}
                                    getOptionSelected={(option, value) => option?._id === value?._id}
                                    disabled={userType === "MIS Operator" ? requisitionDetailsData?.isDisabled || (requisitionResponseData?.teamLeaderRequisitionDetails || [])?.length > 0 : true}
                                    value={requisitionDetailsData?.division || null}
                                    freeSolo={requisitionDetailsData?.isDisabled}
                                    onChange={divisionChangeHandler}
                                    filterSelectedOptions
                                    renderInput={(params) =>
                                        <TextField
                                            {...params}
                                            variant="outlined"
                                            required={true}
                                            placeholder="Division"
                                        />
                                    }
                                />
                            </div>
                            <div className='reqDetailsBasicInfo'>
                                <div className='reqDetails_headings'>Priority*</div>
                                <Autocomplete
                                    id="multiple-limit-tags"
                                    className="createRequisition_textbox"
                                    options={priority}
                                    getOptionLabel={(option) => option.name || ""}
                                    getOptionSelected={(option, value) => option?.name === value?.name}
                                    disabled={userType !== "MIS Operator" || requisitionDetailsData?.status?.statusCode === configJSON?.requisitionStatusCodes?.FILLED}
                                    value={requisitionDetailsData?.priority || null}
                                    onChange={priorityChangeHandler}
                                    filterSelectedOptions
                                    renderInput={(params) =>
                                        <TextField
                                            {...params}
                                            variant="outlined"
                                            required={true}
                                            placeholder="Priority"
                                        />
                                    }
                                />
                            </div>
                            <div className='reqDetailsBasicInfo'>
                                <div className='reqDetails_headings'>Minimum Bill Rate</div>
                                <FormControl fullWidth variant="outlined">
                                    <OutlinedInput
                                        placeholder="Minimum Bill Rate"
                                        className="createRequisition_textbox_outline"
                                        // disabled={userType === "MIS Operator" ? false : true}
                                        disabled={userType !== "MIS Operator" || requisitionDetailsData?.status?.statusCode === configJSON?.requisitionStatusCodes?.FILLED}
                                        type='number'
                                        value={requisitionDetailsData?.minimumBillRate || ""}
                                        onChange={minimumbillRateChangeHandler}
                                        inputProps={{ min: 0 }}
                                    />
                                </FormControl>
                            </div>
                            <div className='reqDetailsBasicInfo'>
                                <div className='reqDetails_headings'>Maximum Bill Rate</div>
                                <FormControl fullWidth variant="outlined">
                                    <OutlinedInput
                                        placeholder="Minimum Bill Rate"
                                        // disabled={userType === "MIS Operator" ? false : true}
                                        disabled={userType !== "MIS Operator" || requisitionDetailsData?.status?.statusCode === configJSON?.requisitionStatusCodes?.FILLED}
                                        className="createRequisition_textbox_outline"
                                        type='number'
                                        value={requisitionDetailsData?.maxiMumBillRate || ""}
                                        onChange={MaximumbillRateChangeHandler}
                                        inputProps={{ min: 0 }}
                                    />
                                </FormControl>
                            </div>
                            <div className='reqDetailsBasicInfo'>
                                <div className='reqDetails_headings'>Currency Unit</div>
                                <Autocomplete
                                    id="multiple-limit-tags"
                                    className="createRequisition_textbox"
                                    // disabled={userType === "MIS Operator" ? false : true}
                                    disabled={userType !== "MIS Operator" || requisitionDetailsData?.status?.statusCode === configJSON?.requisitionStatusCodes?.FILLED}
                                    options={currencyBillRate}
                                    getOptionLabel={(option) => option.value ? option.value : ""}
                                    getOptionSelected={(option, value) => option?.value === value?.value}
                                    value={requisitionDetailsData?.currency || null}
                                    onChange={currencyBillRateChangeHandler}
                                    filterSelectedOptions
                                    renderInput={(params) =>
                                        <TextField
                                            {...params}
                                            variant="outlined"
                                            required={true}
                                            placeholder="Currency Unit"
                                        />
                                    }
                                />
                            </div>
                            {requisitionDetailsData.placementType?.PositionType !== "Contract" ?
                                <>
                                    <div className='reqDetailsBasicInfo'>
                                        <div className='reqDetails_headings'>Fee(%)</div>
                                        <FormControl fullWidth variant="outlined">
                                            <OutlinedInput
                                                placeholder="Fee"
                                                className="createRequisition_textbox_outline"
                                                type='number'
                                                // disabled={userType === "MIS Operator" ? false : true}
                                                disabled={userType !== "MIS Operator" || requisitionDetailsData?.status?.statusCode === configJSON?.requisitionStatusCodes?.FILLED}
                                                value={requisitionDetailsData?.fee || ""}
                                                onChange={feeChangeHandler}
                                                inputProps={{ min: 0 }}
                                            />
                                        </FormControl>
                                    </div>
                                </> : ""}


                            <div className='reqDetailsBasicInfo'>
                                <div className='reqDetails_headings'>Opening*</div>
                                <FormControl fullWidth variant="outlined">
                                    <OutlinedInput
                                        placeholder="Openings"
                                        className="createRequisition_textbox_outline"
                                        type='number'
                                        // disabled={userType === "MIS Operator" ? false : true}
                                        disabled={userType !== "MIS Operator" || requisitionDetailsData?.status?.statusCode === configJSON?.requisitionStatusCodes?.FILLED}
                                        value={requisitionDetailsData?.openings || ""}
                                        onChange={openingChangeHandler}
                                        inputProps={{ min: 0 }}
                                    />
                                </FormControl>
                            </div>

                            <div className='reqDetailsBasicInfo_location'>
                                <div className='reqDetails_headings'>Location*</div>
                                <Autocomplete
                                    id="multiple-limit-tags"
                                    className={requisitionDetailsData?.placementType === "Contract" ? "createRequisition_textbox_outline" : "createRequisition_textbox"}
                                    multiple={true}
                                    // disabled={userType === "MIS Operator" ? false : true}
                                    disabled={userType !== "MIS Operator" || requisitionDetailsData?.status?.statusCode === configJSON?.requisitionStatusCodes?.FILLED}
                                    loading={locationLoading}
                                    loadingText={<CircularProgress />}
                                    options={locationList}
                                    getOptionLabel={(option) =>
                                        option ? option : ""
                                    }
                                    filterSelectedOptions
                                    autoHighlight
                                    value={requisitionDetailsData?.location || []}
                                    onChange={locationChangeHandler}
                                    renderInput={(params) =>
                                        <TextField
                                            {...params}
                                            variant="outlined"
                                            value={locationSearchText}
                                            onChange={(e) => locationTextFieldChangeHandler(e)}
                                            required={true}
                                            placeholder="Search locations"
                                        />
                                    }
                                />
                            </div>


                            <div className='reqDetailsBasicInfo'>
                                <div className='reqDetails_headings'>Start Date</div>
                                <DatePicker
                                    className="createRequisition_textbox_datapicker"
                                    selected={requisitionDetailsData?.startDate}
                                    onChange={startDateChangeHandler}
                                    dateFormat="MM/dd/yyyy"
                                    // disabled={userType === "MIS Operator" ? false : true}
                                    disabled={userType !== "MIS Operator" || requisitionDetailsData?.status?.statusCode === configJSON?.requisitionStatusCodes?.FILLED}
                                    showIcon
                                    minDate={new Date()}
                                />
                            </div>
                            <div className='reqDetailsBasicInfo'>
                                <div className='reqDetails_headings'>End Date</div>
                                <DatePicker
                                    className="createRequisition_textbox_datapicker"
                                    selected={requisitionDetailsData?.endDate}
                                    onChange={endDateChangeHandler}
                                    // disabled={userType === "MIS Operator" ? false : true}
                                    disabled={userType !== "MIS Operator" || requisitionDetailsData?.status?.statusCode === configJSON?.requisitionStatusCodes?.FILLED}
                                    dateFormat="MM/dd/yyyy"
                                    showIcon
                                    minDate={new Date()}
                                />
                            </div>

                            <div className='reqDetailsBasicInfo'>
                                <div className='reqDetails_headings'>Minimum Experience*</div>
                                <FormControl fullWidth variant="outlined">
                                    <OutlinedInput
                                        placeholder="Minimum Experience"
                                        className={"createRequisition_textbox_outline"}
                                        type='number'
                                        // disabled={userType === "MIS Operator" ? false : true}
                                        disabled={userType !== "MIS Operator" || requisitionDetailsData?.status?.statusCode === configJSON?.requisitionStatusCodes?.FILLED}
                                        value={requisitionDetailsData?.minimumExperienceLevel ?? ""}
                                        onChange={minimumExperienceHandler}
                                        inputProps={{ min: 0 }}
                                    />
                                </FormControl>
                            </div>
                            <div className='reqDetailsBasicInfo'>
                                <div className='reqDetails_headings'>Maximum Experience*</div>
                                <FormControl fullWidth variant="outlined">
                                    <OutlinedInput
                                        placeholder="Maximum Experience"
                                        className="createRequisition_textbox_outline"
                                        type='number'
                                        // disabled={userType === "MIS Operator" ? false : true}
                                        disabled={userType !== "MIS Operator" || requisitionDetailsData?.status?.statusCode === configJSON?.requisitionStatusCodes?.FILLED}
                                        value={requisitionDetailsData?.maximumExperienceLevel || ""}
                                        onChange={maximumExperienceHandler}
                                        inputProps={{ min: 0 }}
                                    />
                                </FormControl>
                            </div>

                            <div className='reqDetailsBasicInfo'>
                                <div className='reqDetails_headings'>Status*</div>
                                <Autocomplete
                                    id="multiple-limit-tags"
                                    className="createRequisition_textbox"
                                    options={status}
                                    getOptionLabel={(option) => option.name ? option.name : ""}
                                    getOptionSelected={(option, value) => option?._id === value?._id}
                                    disabled={userType === "Recruiter" || userType === 'Admin' ? true : false}
                                    value={requisitionDetailsData?.status || null}
                                    onChange={statusChangeHandler}
                                    filterSelectedOptions
                                    renderInput={(params) =>
                                        <TextField
                                            {...params}
                                            variant="outlined"
                                            required={true}
                                            placeholder="Status"
                                        />
                                    }
                                />
                            </div>
                            {requisitionDetailsData?.status?.name === 'FILLED' ?
                                <div className='reqDetailsBasicInfo'>
                                    <div className='reqDetails_headings'>Filled By</div>
                                    <FormControl fullWidth variant="outlined">
                                        <OutlinedInput
                                            placeholder="Filled By"
                                            className="createRequisition_textbox_outline"
                                            value={requisitionDetailsData?.filledBy ? requisitionDetailsData?.filledByDetails?.email || "" : ""}
                                            type='text'
                                            disabled
                                            onChange={filledByChangeHandler}
                                        />
                                    </FormControl>
                                </div> : ""
                            }
                            <div className='reqDetailsBasicInfo'>
                                <div className='reqDetails_headings'>Assigned To*</div>
                                <FormControl fullWidth variant="outlined">
                                    {requisitionDetailsData?.assignedTo ?
                                        <Tooltip

                                            title={< React.Fragment >
                                                <h3 >{`${requisitionDetailsData?.assignedTo?.email || ""}`}</h3>
                                            </React.Fragment>}>
                                            <Autocomplete
                                                id="multiple-limit-tags"
                                                className="createRequisition_textbox"
                                                options={getFilteredRecruiterLeaderOptions()}
                                                getOptionLabel={(option) =>
                                                    option.email ? option.email : ""
                                                }
                                                getOptionSelected={(option, value) => option?.id === value?.id}
                                                filterSelectedOptions
                                                autoHighlight
                                                freeSolo={requisitionDetailsData?.isDisabled}
                                                disabled={userType === "MIS Operator" ? requisitionDetailsData.isDisabled || (requisitionResponseData?.teamLeaderRequisitionDetails || [])?.length > 0 : true}
                                                value={requisitionDetailsData?.assignedTo || null}
                                                onChange={assignToChangeHandler}
                                                renderInput={(params) =>
                                                    <TextField
                                                        {...params}
                                                        variant="outlined"
                                                        required={true}
                                                        placeholder="Assign To"
                                                    />
                                                }
                                            />
                                        </Tooltip> :
                                        <Autocomplete
                                            id="multiple-limit-tags"
                                            className="createRequisition_textbox"
                                            options={getFilteredRecruiterLeaderOptions()}
                                            getOptionLabel={(option) =>
                                                option.email ? option.email : ""
                                            }
                                            getOptionSelected={(option, value) => option?.id === value?.id}
                                            filterSelectedOptions
                                            autoHighlight
                                            freeSolo={requisitionDetailsData.isDisabled}
                                            disabled={userType === "MIS Operator" ? requisitionDetailsData.isDisabled : true}
                                            value={requisitionDetailsData?.assignedTo || null}
                                            onChange={assignToChangeHandler}
                                            renderInput={(params) =>
                                                <TextField
                                                    {...params}
                                                    variant="outlined"
                                                    required={true}
                                                    placeholder="Assign To"
                                                />
                                            }
                                        />}
                                </FormControl>
                            </div>
                            {(userType === "MIS Operator" || userType === "Organization Admin") && requisitionResponseData?.status?.statusCode === configJSON?.requisitionStatusCodes?.OPEN && (
                                <div className='reqDetailsBasicInfo_ChangeAssignedTo'>
                                    <button className='changeRlButton' onClick={(e) => openChangeRecruitmentLeaderHandler()}>
                                        <img src={transferArrow} alt='transferArrow' />
                                        <span>Change Recruitment leader</span>
                                    </button>
                                </div>
                            )}
                        </div>
                        <div className='reqDetailsBasicInfo_jobDesCription textAreaJD'>
                            <div className='reqDetails_headings'>Comment</div>
                            <TextareaAutosize
                                minRows={7}
                                maxRows={7}
                                aria-label="maximum height"
                                placeholder="Comments"
                                sx={stylesSX.customTextArea}
                                disabled={userType !== "MIS Operator" || requisitionDetailsData?.status?.statusCode === configJSON?.requisitionStatusCodes?.FILLED}
                                value={requisitionDetailsData?.comment || ''}
                                onChange={commentChangeHandler}
                            />
                        </div>
                        <div className='reqDetailsBasicInfo_jobDesCription textAreaJD'>
                            <div className='reqDetails_headings'>Job Description</div>
                            <TextareaAutosize
                                minRows={7}
                                maxRows={7}
                                aria-label="maximum height"
                                placeholder="Job Description"
                                sx={stylesSX.customTextArea}
                                // disabled={userType === "MIS Operator" ? false : true}
                                disabled={userType !== "MIS Operator" || requisitionDetailsData?.status?.statusCode === configJSON?.requisitionStatusCodes?.FILLED}
                                value={requisitionDetailsData?.jobDescription || ''}
                                onChange={jobDescriptionChangeHandler}
                            />
                        </div>

                        <div className='reqDetailsBasicInfo_ActionBtnsContainer'>
                            <div className='buttonContainer_viewRequisition_outside'>
                                {
                                    userType === "Recruiter" || userType === "Team Leader" ? "" :
                                        <>
                                            {userType === "Admin" ? "" :

                                                <button variant="contained" className={atvBtn ? "saveButton_viewRequisition_disable" : "saveButton_viewRequisition"} onClick={(e) => saveHandler()}
                                                    disabled={atvBtn}

                                                >
                                                    <span>Save</span>
                                                    {atvBtn ? (<CircularProgress />) : null}
                                                </button>
                                            }
                                            <Button variant='outlined' className="cancelButton_viewRequisition" onClick={(e) => goToDashBoard(e)}>
                                                Cancel
                                            </Button>
                                        </>
                                }
                                {
                                    userType === "MIS Operator" ?
                                        <Button variant='contained' className="cloneRequisitionButton_viewRequisition" onClick={(e) => cloneConfirmRequisitionHandler(e)}>
                                            Clone Requisition
                                        </Button> : ""
                                }
                            </div>


                            {requisitionDetailsData?.documentLink ?
                                <div className='viewButton_container_viewRequisition'>
                                    <Button variant="contained" className="viewDocumentButton_viewRequisition" onClick={(e) => openResume(requisitionDetailsData?.documentLink)}>View Document</Button>
                                </div> : ""
                            }
                        </div>
                    </div>
                }

                {/* Right Side Activity Card */}
                <div className='reqDetailsRightCard'>
                    <RecentActivities requisitionId={requisitionId} idContextTest={idContextTest} userType={userType} userRecords={userRecords} userRole={userRole} userRecruitmentpartnerId={userRecruitmentpartnerId}
                        activCount={activCount} setactivCount={setactivCount}
                        page="req" />

                    <div className='recentActivities_BtnGroup'>
                        {(requisitionResponseData?.statusDetails?.name === "OPEN") && <>
                            {isDataLoading ? null :
                                userType === "Recruitment Leader" || userType === "MIS Operator" || userType === "Organization Admin" ?
                                    <Button variant="contained" className='button_AssignRecruiter' onClick={(e) => openModal()}>
                                        <div className='maindivButton_requisitionBody'>
                                            {((requisitionResponseData?.teamLeaderRequisitionDetails?.length > 0)) ? <VisibilityIcon className='iconDivision_viewRequisition' /> : <PersonAdd className='iconDivision_viewRequisition' />}
                                            {(requisitionResponseData?.teamLeaderRequisitionDetails?.length > 0) ? <span>View Assigned Team</span> : <span>Assign Team </span>}
                                        </div>
                                    </Button> :
                                    (userType === "Team Leader" || userType === "Recruiter") ?
                                        <Button variant="contained" className='button_AssignRecruiter' onClick={(e) => openRecruiterRequisitionModal()}>
                                            <div className='maindivButton_requisitionBody'>
                                                {((requisitionResponseData?.recruiterRequisitionDetails?.length > 0)) ? <VisibilityIcon className='iconDivision_viewRequisition' /> : <PersonAdd className='iconDivision_viewRequisition' />}
                                                {(requisitionResponseData?.recruiterRequisitionDetails?.length > 0) ? (userType === "Recruiter") ? <span>View Assignment</span> : <span>View Assigned Recruiter</span> : <span>Assign Recruiter</span>}
                                            </div>
                                        </Button>
                                        : null
                            }

                            {userType === "Recruitment Leader" || userType === "Recruiter" || userType === "Team Leader" || userType === "MIS Operator" || userType === "Organization Admin" ?
                                <Button variant="contained" className='button_candidateSearch' onClick={(e) => goToSearchCandidate()}>
                                    <div className='maindivButton_requisitionBody'>
                                        <Search className='iconDivision_viewRequisition' />
                                        <span>Candidate Search</span>
                                    </div>
                                </Button>
                                : null}
                            {userType === "Recruitment Leader" || userType === "Recruiter" || userType === "Team Leader" || userType === "MIS Operator" || userType === "Organization Admin" ?
                                <Button variant="contained" className='button_uploadResume' onClick={(e) => handleUploadResumes()}>
                                    <div className='maindivButton_requisitionBody'>
                                        <CloudUpload className='iconDivision_viewRequisition' />
                                        <span>Upload Resume</span>
                                    </div>
                                </Button>
                                : null}
                        </>}
                    </div>
                </div>

            </div >

            <TeamLeaderRequistionAssignment
                modalIsOpen={modalIsOpen}
                closeModal={closeModal}
                divisionByOrgData={divisionByOrgData}
                requisitionResponseData={requisitionResponseData}
                status={status}
                requisitionId={requisitionId}
                ref={teamLeaderRequisitionRef} // reference for Child component
                getRequisitionDetail={getRequisitionDetail}
                setSelectedTeam={setSelectedTeam}
                selectedTeam={selectedTeam}
                openRecruiterRequisitionModal={openRecruiterRequisitionModal}
                setmodalIsOpen={setmodalIsOpen}
                recruitmentpartnerId={userRecruitmentpartnerId}
                displayName={userRecords.displayName}
                id={idContextTest}
                userType={userType}
            />

            <RecruiterRequisitionAssignment
                recruiterModalIsOpen={recruiterModalIsOpen}
                setRecruiterModalIsOpen={setRecruiterModalIsOpen}
                requisitionResponseData={requisitionResponseData}
                closeRecruiterRequisitionModal={closeRecruiterRequisitionModal}
                divisionByOrgData={divisionByOrgData}
                ref={recruiterRequisitionRef} // reference for Child component
                status={status}
                getRequisitionDetail={getRequisitionDetail}
                selectedTeam={selectedTeam}
            />

            {/* Clone Requisition Modal */}
            <Dialog
                onClose={closeCloneRequisitionModal}
                open={cloneRequisitionModal}
                aria-labelledby="customized-dialog-title"
                maxWidth="xs"
                fullWidth={true}
            >
                <DialogContent >
                    <div className="fs-semi-bold f-color fs-18">Do you want to clone this requisition?</div>
                </DialogContent>
                <DialogActions>
                    <div className='button_Container_CreateRequisition cloneRequisitionBtnContainer'>
                        <Button variant="contained" color="primary" className="cloneRequisition_createRequisition_dialogBtn" onClick={cloneRequisitionHandler}
                        >
                            Confirm
                        </Button>
                        <Button variant="contained" color="secondary" className='ButtonCancel_cloneRequisition' onClick={closeCloneRequisitionModal}
                        >
                            Cancel
                        </Button>
                    </div>
                </DialogActions>
            </Dialog>

            <Dialog
                onClose={() => setopenRecuitmentLeaderChangeDialog(false)}
                open={openRecuitmentLeaderChangeDialog}
                aria-labelledby="customized-dialog-title"
                maxWidth="md"
                fullWidth={true}
                className='changeRecruitmentLeaderDialog'
            >
                <DialogContent className='dialogContent'>
                    <div className='titleContainer_dialogContent'>
                        <img src={transferArrow} alt="Change Recruitment Leader Icon" />
                        <span>Change Recruitment Leader</span>
                    </div>
                    <div className='referenceIdContainer'>
                        <span className='title'>Reference ID : </span>
                        <span>{requisitionDetailsData?.reqreferenceId}</span>
                    </div>
                    {recruitmentLeaderChangeObject?.isDataLoading ? <div className='circularLoaderContainer'>
                        <CircularProgress />
                    </div> :
                        <div className='fieldsContainer_mainDiv'>
                            <div className="fieldsContainer">
                                <span className='fieldTitle'>Assigned To</span>
                                <OutlinedInput
                                    placeholder="Recruitment Leader"
                                    value={recruitmentLeaderChangeObject?.oldRecuitmentLeader?.email || ""}
                                    type='text'
                                    disabled
                                />
                            </div>
                            <div className="fieldsContainer">
                                <span className='fieldTitle'>Division *</span>
                                <Autocomplete
                                    id="multiple-limit-tags"
                                    options={recruitmentLeaderChangeObject?.divisionList || []}
                                    getOptionLabel={(option) =>
                                        option.divisionName ? option.divisionName : ""
                                    }
                                    getOptionSelected={(option, value) => option?._id === value?._id}
                                    value={recruitmentLeaderChangeObject?.selectedDivision || null}
                                    filterSelectedOptions
                                    onChange={(e, value) => divisionChangeHandler_recruitmentLeaderChange(value)}
                                    renderInput={(params) =>
                                        <TextField
                                            {...params}
                                            variant="outlined"
                                            required={true}
                                            placeholder="Choose Division"
                                        />
                                    }
                                />
                            </div>
                            <div className="fieldsContainer">
                                <span className='fieldTitle'>Reassigned to *</span>
                                <Autocomplete
                                    id="multiple-limit-tags"
                                    className="createRequisition_textbox"
                                    options={recruitmentLeaderChangeObject?.recruiterLeaderList || []}
                                    getOptionLabel={(option) => option.email ? option.email : ""}
                                    getOptionSelected={(option, value) => option?.id === value?.id}
                                    value={recruitmentLeaderChangeObject?.newRecuitmentLeader || null}
                                    filterSelectedOptions
                                    onChange={(e, value) => recruitmentLeaderChangeHandler_reassignRecruiterLeader(value)}
                                    renderInput={(params) =>
                                        <TextField
                                            {...params}
                                            variant="outlined"
                                            required={true}
                                            placeholder="Select Recruitment Leader"
                                        />
                                    }
                                />
                            </div>
                        </div>
                    }
                </DialogContent>
                <DialogActions className='diallogActions'>
                    <button className="cancel-button-assignTeamLeader" onClick={() => setopenRecuitmentLeaderChangeDialog(false)}>
                        Cancel
                    </button>
                    <button
                        className={(recruitmentLeaderChangeObject?.isDataUpdating ? true : false) ? 'saveButton_changeAssignedToDisabled' : 'saveButton_changeAssignedTo'}
                        onClick={(e) => handleRecruitmentLeaderChange()}
                        disabled={(recruitmentLeaderChangeObject?.isDataUpdating || recruitmentLeaderChangeObject?.isDataLoading) ? true : false}
                    >
                        <span>Save</span>
                        {(recruitmentLeaderChangeObject?.isDataUpdating ? true : false) ? (<CircularProgress className="circularProgress_updateButton" />) : null}
                    </button>
                </DialogActions>
            </Dialog>


            {/* Resume modal */}

            <UploadResumeModal

                showResumeModal={showResumeModal}
                setShowResumeModal={setShowResumeModal}
                id={idContextTest}
                userRecruitmentpartnerId={userRecruitmentpartnerId}
            />


            <NotificationContainer />
        </div >
    )
}

export default RequisitionDetailsBody

